module.exports = __webpack_public_path__ + "static/media/rentLease.140b4c3f.svg";